module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av310-2722392dba6f1b58cd3867b0ba883e3f.jpg";